import api, { unauthorizedApiInstance } from './index';

const AuthApi = {
    login: (body, config) => unauthorizedApiInstance.post('/login', body, config),
    createAccount: (body, config) => api.post('/signup/check', body, config),
    createPassword: (body, config) => api.post('/password/create', body, config),
    forgotPassword: (body, config) => api.post('/password/forgot', body, config)
};

export default AuthApi;
